import { Outlet } from "react-router-dom";
import { Row, Container, Card } from "react-bootstrap";
import Logo from "../../assets/img/brand/scandi-name-automation.svg";
import NameLogo from "../../assets/img/brand/scandi-name-automation.png";

export default function AuthLayout() {
  return (
    <div className="page main-signin-wrapper">
      <Row className="signpages text-center">
        <div className="align-items-center bg-primary company__info">
          <img src={Logo} alt="Super Admin Control Panel" />

          <h5 className="mt-4 text-white" style={{ position: "relative" }}>
            Super Admin Control Panel
          </h5>
        </div>
        <div className="login_form">
          <Container fluid>
            <Row className="row-sm">
              <Card.Body className="mt-2 mb-2">
                <img
                  src={NameLogo}
                  alt="Super Admin Control Panel"
                  className=" d-sm-none header-brand-img text-start float-start mb-4 auth-light-logo"
                />
                <Outlet />
              </Card.Body>
            </Row>
          </Container>
        </div>
      </Row>
    </div>
  );
}
